import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "hp-quibbler-hp7-harry-in-hiding",
  name: `The Quibbler\n'Harry in Hiding'`,
  nameFormatted: {
    primary: "The Quibbler",
    secondary: "'Harry in Hiding'",
  },
  origin: `Harry Potter and the Deathly Hallows`,

  category: replicaCategories.harryPotter,

  versions: [Version1],
};

export default data;
